import { render } from "./OrderCancel.vue?vue&type=template&id=6bc77404&scoped=true"
import script from "./OrderCancel.vue?vue&type=script&lang=js"
export * from "./OrderCancel.vue?vue&type=script&lang=js"

import "./OrderCancel.vue?vue&type=style&index=0&id=6bc77404&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc77404"]])

export default __exports__